import apiCall from '../../apiCall/apiCall';
// This class handles any API calls related to hubs.
class Hub {
  static all() {
    return apiCall('GET', 'api/places/hubs');
  }
  static show(id) {
    return apiCall('GET', `api/places/hubs/${id}`);
  }
}

export default Hub;
